import { learnModuleName } from '../../../../../common/src/learn_rules.ts';
import { LearnLevel, LearnModule, LearnModuleProgress } from '../../../../../common/src/model.ts';
import { RhythmSessionResult } from '../../../../../common/src/rhythm_echo.ts';
import { LearnSummaryScreen, summaryScreenIds } from '../learn_summary_screen.tsx';

// The ids the shared summary screen renders for this exercise; the screen itself builds them from
// the same helper, so nothing here is a string that only happens to match (issue #3518).
const ids = summaryScreenIds('rhythm');
export const rhythmSummaryScreenId = ids.screen;
export const rhythmSummaryScoreTestId = ids.score;
export const rhythmSummarySquareTestId = ids.square;
export const rhythmSummaryUnlockedTestId = ids.unlocked;

// The Rhythm Echo session summary (issue #3473), from the "Session summary" artboard: the shared
// Learn summary screen (issue #3518) fed this session's score, best streak and one square per
// pattern in its result colour. Presentational: `module` is the member's module progress after the
// session was recorded, and the flags come from recordLearnSession.
export const RhythmSummaryScreen = ({
  level,
  summary,
  module,
  dayStreak,
  isNewBest,
  unlockedLevel,
  onPlayAgain,
  backLabel,
  onBack,
  learnModule = LearnModule.RhythmEcho,
}: {
  learnModule?: LearnModule; // the exercise the session was played in: Rhythm Echo, or Sing Rhythm (issue #3723)
  level: LearnLevel;
  summary: RhythmSessionResult;
  module: LearnModuleProgress;
  dayStreak: number;
  isNewBest: boolean;
  unlockedLevel?: LearnLevel; // the level this session unlocked, if any
  onPlayAgain: () => void;
  backLabel: string; // "Back to Rhythm"
  onBack: () => void;
}) => (
  <LearnSummaryScreen
    idPrefix="rhythm"
    moduleName={learnModuleName(learnModule)}
    level={level}
    score={summary.score}
    bestStreak={summary.bestStreak}
    squares={summary.patterns.map((result) => result.color)}
    module={module}
    dayStreak={dayStreak}
    isNewBest={isNewBest}
    unlockedLevel={unlockedLevel}
    onPlayAgain={onPlayAgain}
    backLabel={backLabel}
    onBack={onBack}
  />
);
